export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Energy.e531be93.PNG";